import { create } from 'zustand';

interface LayerStore {
  hiddenDynamicLayerIds: string[];
  hiddenWmsLayerIds: string[];
  ldMapVisible: boolean;

  toggleDynamicLayer: (layerId: string) => void;
  toggleWmsLayer: (layerId: string) => void;
  toggleLdMap: () => void;
  getHiddenLayerIds: () => string[];
}

export const useLayerStore = create<LayerStore>((set, get) => ({
  hiddenDynamicLayerIds: [],
  hiddenWmsLayerIds: [],
  ldMapVisible: false,

  toggleDynamicLayer: (layerId) => set((state) => ({
    hiddenDynamicLayerIds: state.hiddenDynamicLayerIds.includes(layerId)
      ? state.hiddenDynamicLayerIds.filter((id) => id !== layerId)
      : [...state.hiddenDynamicLayerIds, layerId],
  })),

  toggleWmsLayer: (layerId) => set((state) => ({
    hiddenWmsLayerIds: state.hiddenWmsLayerIds.includes(layerId)
      ? state.hiddenWmsLayerIds.filter((id) => id !== layerId)
      : [...state.hiddenWmsLayerIds, layerId],
  })),

  toggleLdMap: () => set((state) => ({
    ldMapVisible: !state.ldMapVisible,
  })),

  getHiddenLayerIds: () => {
    const state = get();
    return [...state.hiddenDynamicLayerIds, ...state.hiddenWmsLayerIds];
  },
}));
